<template>
    <div class="reset-password-component-container">
        <div class="component-wrapper">
            <LoginHeader />
            <div class="reset-password-page-container">
                <div v-if="!resettingPasswordSuccesseded" class="reset-password-form-container">
                    <div class="form-container">
                        <form class="reset-password-form" @submit="resetPasswordHandle">
                            <div class="info-text-container">
                                <!-- <p class="info-text">
                                    Verander het wachtwoord voor:
                                </p> -->
                                <p class="info-text">
                                    {{ $t('change_password_for') }}
                                </p>
                                <!-- <p class="info-text">
                                    wachtwoord voor:
                                </p> -->
                                <p class="user-email">
                                    {{ email }}
                                </p>
                            </div>

                            <div class="input-container">
                                <div class="form-section-wrapper password-section-container">
                                    <div class="show-hide-password-container" @click="showHidePassword">
                                        <img :src="require(`../../assets/icons/${showPassword ? 'show' : 'hide'}_password.png`)"
                                            alt="password icon">
                                    </div>
                                    <div class="password-input-container">
                                        <!-- <input id="password" class="form-input"
                                            :class="passwordLengthInvalid ? 'error-password-length' : passwordStrength"
                                            name="password" :type="showPassword ? 'text' : 'password'"
                                            @keyup="checkPasswordStrength" @blur="checkPasswordLength"
                                            placeholder="Bedenk nieuw wachtwoord" required /> -->
                                        <input id="password" class="form-input"
                                            :class="[{ 'blocked': resettingPasswordLoading }, passwordLengthInvalid ? 'error-password-length' : passwordStrength]"
                                            name="password" :type="showPassword ? 'text' : 'password'"
                                            @keyup="checkPasswordStrength" @blur="checkPasswordLength"
                                            :placeholder="$t('create_new_password') + '...'" required />
                                    </div>
                                </div>
                                <div v-if="showPasswordMsg" class="password-length-strength-msg-container">
                                    <p :class="passwordMsgColor">{{ $t(`${passwordMsg}`) }}</p>
                                </div>
                            </div>

                            <div class="input-container">
                                <div class="form-section-wrapper">
                                    <!-- <input id="repeat-password" class="form-input"
                                        :class="confirmPasswordNotMatch ? 'error-password-not-match' : ''"
                                        name="repeat-password" type="password" placeholder="Herhaal dit wachtwoord"
                                        required /> -->
                                    <input id="repeat-password" class="form-input"
                                        :class="[{'error-password-not-match': confirmPasswordNotMatch, 'blocked': resettingPasswordLoading}]"
                                        name="repeat-password" type="password"
                                        :placeholder="$t('re_enter_password') + '...'" required />
                                </div>
                                <div v-if="confirmPasswordNotMatch" class="error-msg-password-not-match-container">
                                    <!-- <p class="red">Je wachtwoord komt niet overeen.</p> -->
                                    <p class="red">{{ $t('password_does_not_match') }}</p>
                                </div>
                            </div>

                            <div class="form-section-wrapper reset-password-btn-and-error-msg-container">
                                <div class="reset-password-btn-wrapper">
                                    <div v-if="resettingPasswordLoading" class="loading-spinner-container">
                                        <!-- <div class="circular-progress-indicator"></div> -->
                                        <div class="spinner">
                                            <img src="../../assets/imgs/loading_spinner.png" alt="Spinner Image">
                                        </div>
                                    </div>
                                    <!-- <input v-else id="reset-password-btn" class="reset-password-btn btn" type="submit"
                                        value="bevestig" /> -->
                                    <input v-else id="reset-password-btn" class="reset-password-btn btn" type="submit"
                                        :value="$t('confirm')" />
                                </div>
                                <div class="error-reset-password-info-msg-container">
                                    <p v-if="resettingPasswordFailed" class="error-reset-password-info-msg red">
                                        {{ $t(`${resettingPasswordMsg}`) }}
                                    </p>
                                </div>
                            </div>
                        </form>

                        <div class="can-not-reset-password-text-container">
                            <!-- <p>Lukt het wachtwoord resetten niet?</p> -->
                            <p>{{ $t('cant_reset_password') }}</p>
                            <!-- <p>Vraag hulp bij je fit20 trainer.</p> -->
                            <p>{{ $t('ask_trainer_for_hulp') }}</p>
                        </div>
                    </div>
                </div>
                <div v-else class="password-reset-success-container">
                    <div class="password-reset-success-content-container">
                        <div class="info-text-container">
                            <p class="info-text">
                                <!-- Wachtwoord resetten is gelukt! -->
                                {{ $t('password_reset_successful') }}
                                <br><br>
                                <!-- Je kunt opnieuw inloggen -->
                                {{ $t('you_can_login_again') }}
                            </p>
                        </div>
                        <div class="login-btn-container">
                            <!-- <div class="login-btn" @click="goToLoginPage">Login</div> -->
                            <div class="login-btn" @click="goToLoginPage">{{ $t('login') }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <LoginFooter />
        </div>
    </div>
</template>

<script>
import LoginHeader from './LoginHeader.vue';
import LoginFooter from './LoginFooter.vue';
import { passwordStrength } from 'check-password-strength';
export default {
    name: "ResetPasswordPage",
    components: {
        LoginHeader,
        LoginFooter,
    },
    data() {
        return {
            email: '',
            resettingPasswordLoading: false,
            resettingPasswordFailed: false,
            resettingPasswordSuccesseded: false,
            resettingPasswordMsg: '',
            confirmPasswordNotMatch: false,
            showPasswordMsg: false,
            passwordLengthInvalid: false,
            passwordMsg: '',
            passwordMsgColor: 'red',
            passwordStrength: '',
            showPassword: false,
        }
    },
    methods: {
        showHidePassword: function () {
            this.showPassword = !this.showPassword;
        },
        goToLoginPage: function () {
            this.email = '';
            this.resettingPasswordLoading = false;
            this.resettingPasswordFailed = false;
            this.resettingPasswordSuccesseded = false;
            this.resettingPasswordMsg = '';
            this.confirmPasswordNotMatch = false;
            this.showPasswordMsg = false;
            this.passwordLengthInvalid = false;
            this.passwordMsg = '';
            this.passwordMsgColor = 'red';
            this.passwordStrength = '';
            this.showPassword = false;
            this.$store.backToLoginPage();
        },
        checkPasswordStrength: function () {
            this.confirmPasswordNotMatch = false;
            this.showPasswordMsg = false;
            this.passwordLengthInvalid = false;
            this.passwordMsg = '';
            this.passwordStrength = '';
            this.passwordMsgColor = 'red';
            const passwordInput = document.getElementById('password');

            if (passwordInput.value != "") {
                const passwordStrengthResult = passwordStrength(passwordInput.value).value;

                switch (passwordStrengthResult) {
                    case "Too weak":
                    case "Weak": {
                        this.showPasswordMsg = true;
                        this.passwordMsg = 'this_password_weak';
                        this.passwordStrength = 'weak';
                        this.passwordMsgColor = 'red';
                    }
                        break;
                    case "Medium": {
                        this.showPasswordMsg = true;
                        this.passwordMsg = 'this_password_ok';
                        this.passwordStrength = 'medium';
                        this.passwordMsgColor = 'blue';
                    }
                        break;
                    case "Strong": {
                        this.showPasswordMsg = true;
                        this.passwordMsg = 'this_password_strong';
                        this.passwordStrength = 'strong';
                        this.passwordMsgColor = 'green';
                    }
                }

            }
            else {
                this.checkPasswordLength();
            }
        },
        checkPasswordLength: function () {
            if (!this.showPasswordMsg) {
                this.confirmPasswordNotMatch = false;
                this.showPasswordMsg = false;
                this.passwordLengthInvalid = false;
                this.passwordMsg = '';
                this.passwordStrength = '';
                this.passwordMsgColor = 'red';
            }
            const passwordInput = document.getElementById("password");
            if (passwordInput.value.length < 6) {
                this.passwordLengthInvalid = true;
                this.showPasswordMsg = true;
                this.passwordMsg = 'create_password_with_at_least_6_characters';
                return false;
            }
            else {
                return true;
            }
        },
        resetPasswordHandle: async function (e) {
            e.preventDefault();

            this.confirmPasswordNotMatch = false;

            try {
                const checkPasswordStrengthResponse = this.checkPasswordLength();

                if (checkPasswordStrengthResponse) {
                    // The password has 6 characters or more
                    this.resettingPasswordLoading = false;
                    this.resettingPasswordFailed = false;
                    this.resettingPasswordSuccesseded = false;
                    this.resettingPasswordMsg = '';

                    const password = document.getElementById("password").value;
                    const confirmPassword = document.getElementById("repeat-password").value;

                    if (password !== confirmPassword) {
                        this.confirmPasswordNotMatch = true;
                    }
                    else {
                        this.resettingPasswordLoading = true;

                        if (this.$route.params.email && this.$route.params.email != '' && this.$route.params.token && this.$route.params.token != '') {
                            const resetPasswordData = {
                                email: this.$route.params.email,
                                token: this.$route.params.token,
                                password: password,
                            }

                            const resettingPasswordResponse = await fetch('../../api/user/resetPassword', {
                                method: 'POST',
                                headers: {
                                    'Accept': 'application/json',
                                    'Content-Type': 'application/json; charset=UTF-8',
                                },
                                body: JSON.stringify(resetPasswordData),
                            });

                            const resettingPasswordResponseJson = await resettingPasswordResponse.json();

                            if (!resettingPasswordResponseJson.status) {
                                this.resettingPasswordFailed = true;
                                this.resettingPasswordMsg = resettingPasswordResponseJson.message;
                                this.resettingPasswordLoading = false;
                            }
                            else {
                                this.$store.showFooterBackBtn = false;
                                this.resettingPasswordSuccesseded = true;
                            }
                        }
                    }
                }
                else {
                    this.resettingPasswordFailed = true;
                    this.resettingPasswordMsg = 'enter_valid_data';
                }

                this.resettingPasswordLoading = false;
            }
            catch (err) {
                console.log("Something went wrong!");
                console.log(err);
                this.resettingPasswordMsg = "something_went_wrong_try_again";
                this.resettingPasswordLoading = false;
            }
        }
    },
    async created() {
        // console.log(this.$route.params);
        if (this.$route.params && this.$route.params.email && this.$route.params !== '') {
            this.email = this.$route.params.email;
        }
        // const loggedInUser = await this.$store.checkLoggedinUser();
        // if (loggedInUser) {
        //     this.$router.push('/home');
        // }
    }
};
</script>

<style>
.reset-password-component-container {
    position: relative;
    height: 100vh;
    width: 100%;
}

.reset-password-component-container .component-wrapper {
    height: 100vh;
    display: flex;
    flex-direction: column;
}

.reset-password-component-container .reset-password-page-container {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: auto;
}

.reset-password-component-container .reset-password-form-container {
    width: 88%;
    max-width: 500px;
    height: 100%;
    /* border: 1px solid red; */
}

.reset-password-component-container .form-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    /* border: 1px solid red; */
}

.reset-password-component-container .reset-password-form {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    /* border: 1px solid blue; */
}

.reset-password-component-container .info-text-container {
    width: 100%;
    max-width: 325px;
    padding: calc(11%) 0 15px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* border: 1px solid red; */
}

.reset-password-component-container .info-text-container .info-text {
    font-size: 30px;
    font-family: 'VAG Rounded Std', sans-serif;
    color: #a0a1a3;
    text-align: center;
    line-height: 35px;
    /* border: 1px solid red; */
    /* padding-bottom: 2px; */
}

.reset-password-component-container .info-text-container .info-text:nth-last-of-type(2) {
    padding-bottom: 5px;
}

.reset-password-component-container .info-text-container .user-email {
    width: 100%;
    font-family: 'Open Sans Std', sans-serif;
    font-size: 19px;
    word-wrap: break-word;
    text-align: center;
    /* border: 1px solid red; */
}

.reset-password-component-container .input-container {
    width: 100%;
    height: 80px;
    padding: 15px 0 20px;
    /* border: 1px solid red; */
}

.reset-password-component-container .input-container:nth-of-type(3) {
    height: 65px;
    margin-bottom: 20px;
}

.reset-password-component-container .form-input {
    width: 100%;
    padding: 9px 6px 6px 9px;
    font-family: 'Open Sans Std', sans-serif;
    font-size: 16px;
    border: 1px solid #92d400;
    border-radius: 10px;
    color: #000000;
    display: inline-block;
    /* margin-bottom: 15px; */
}

.reset-password-component-container .form-input:focus {
    outline: 1px solid #92d400;
}

.reset-password-component-container .password-section-container {
    position: relative;
    /* border: 1px solid red; */
}

.reset-password-component-container .show-hide-password-container {
    position: absolute;
    right: 10px;
    top: 15%;
    bottom: 15%;
    width: 25px;
    display: flex;
    cursor: pointer;
    /* border: 1px solid; */
}

[dir="rtl"] .reset-password-component-container .show-hide-password-container {
  right: auto;
  left: 10px;
}

.reset-password-component-container .show-hide-password-container img {
    width: 100%;
}

.reset-password-component-container input::placeholder,
.reset-password-component-container textarea::placeholder {
    color: #a0a1a3;
}

.reset-password-component-container .error-msg-password-not-match-container,
.reset-password-component-container .password-length-strength-msg-container,
.reset-password-component-container .error-reset-password-info-msg-container {
    padding: 4px 8px;
}

.reset-password-component-container .error-msg-password-not-match-container p,
.reset-password-component-container .password-length-strength-msg-container p,
.reset-password-component-container .error-reset-password-info-msg-container p {
    font-size: 12px;
    font-family: 'Open Sans Std', sans-serif;
}

.reset-password-component-container .error-password-not-match,
.reset-password-component-container .error-password-length {
    border: 1px solid #cb061d;
}

.reset-password-component-container .error-password-not-match:focus,
.reset-password-component-container .error-password-length:focus {
    outline: 1px solid #cb061d;
}

.reset-password-component-container .weak {
    border: 1px solid #cb061d;
    /* color: #cb061d; */
}

.reset-password-component-container .weak:focus {
    outline: 1px solid #cb061d;
}

.reset-password-component-container .medium:focus {
    outline: 1px solid #009df4;
}

.reset-password-component-container .strong:focus {
    outline: 1px solid #92d400;
}

.reset-password-component-container .medium {
    border: 1px solid #009df4;
}

.reset-password-component-container .strong {
    border: 1px solid #92d400;
}

.reset-password-component-container .reset-password-btn-and-error-msg-container {
    width: 100%;
    height: 75px;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.reset-password-component-container .reset-password-btn-wrapper {
    flex: 1;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    /* border: 1px solid red; */
}

.reset-password-component-container .reset-password-btn {
    background: #92d400;
    color: #ffffff;
    font-family: 'VAG Rounded Std', sans-serif;
    font-size: 29px;
    border: none;
    border-radius: 30px;
    cursor: pointer;
    padding: 6px 50px;
    /* border: 1px solid red; */
}

[dir="rtl"] .reset-password-component-container .reset-password-btn {
    font-size: min(26px, calc(14px + 2vw));
    max-height: 45px;
}

.reset-password-component-container .loading-spinner-container {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    /* border: 1px solid red; */
}

.reset-password-component-container .error-reset-password-info-msg-container {
    height: 20px;
    text-align: center;
}

.reset-password-component-container .can-not-reset-password-text-container {
    /* flex: 0.13; */
    display: flex;
    flex-direction: column;
    justify-content: start;
    align-items: center;
    padding: 20px 0 25px;
    /* border: 1px solid red; */
}

.reset-password-component-container .can-not-reset-password-text-container p {
    color: #616365;
    font-family: 'Open Sans Std', sans-serif;
    font-size: 16px;
    text-align: center;
}

.reset-password-component-container .password-reset-success-container {
    width: 88%;
    max-width: 500px;
    height: 100%;
}

.reset-password-component-container .password-reset-success-content-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
}

.reset-password-component-container .login-btn-container {
    flex: 1.5;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-family: 'Open Sans Std', sans-serif;
    padding: calc(15%) 0 0;
}

.reset-password-component-container .login-btn-container p {
    color: #616365;
    padding: 5px 0;
}

.reset-password-component-container .login-btn {
    width: 50%;
    min-width: 200px;
    color: #fff;
    font-family: 'VAG Rounded Std', sans-serif;
    font-size: 28px;
    text-align: center;
    letter-spacing: 1px;
    padding: 6px 0 10px;
    background: #009df4;
    border: 1px solid #fff;
    border-radius: 30px;
    cursor: pointer;
}

[dir="rtl"] .reset-password-component-container .login-btn {
    font-size: min(26px, calc(14px + 2vw));
    max-height: 45px;
    padding: 4px 25px;
}

@media (max-width: 425px) {
    .reset-password-component-container .form-input {
        font-size: calc(10px + 0.8vw);
    }

    .reset-password-component-container .error-msg-password-not-match-container p,
    .reset-password-component-container .password-length-strength-msg-container p,
    .reset-password-component-container .error-reset-password-info-msg-container p {
        font-size: calc(6px + 1.5vw);
    }
}

@media (max-width: 375px) {
    .reset-password-component-container .password-reset-success-container .info-text {
        font-size: 26px;
    }
}

@media (max-width: 320px) {
    .reset-password-component-container .info-text-container .info-text {
        max-width: 200px;
        font-size: 24px;
    }

    .reset-password-component-container .form-input {
        font-size: calc(7px + 1.5vw);
    }

    .reset-password-component-container .error-msg-password-not-match-container p,
    .reset-password-component-container .password-length-strength-msg-container p,
    .reset-password-component-container .error-reset-password-info-msg-container p {
        font-size: calc(6px + 1.2vw);
    }

    .reset-password-component-container .reset-password-btn {
        font-size: 20px;
    }

    .reset-password-component-container .can-not-reset-password-text-container p {
        font-size: calc(10px + 1.5vw);
    }

    .reset-password-component-container .password-reset-success-container .info-text {
        max-width: 300px;
        font-size: calc(12px + 3.5vw);
    }
}
</style>